import React, { FC } from 'react';
import { DeliveryState } from 'types/api';
import AuthButton from 'components/Button/AuthButton';

interface Props {
  deliveryStatus: DeliveryState;
  handleConfirmDialog: () => void;
}

const DeliveryButton: FC<Props> = props => {
  const { deliveryStatus, handleConfirmDialog } = props;

  const getDeliveryText = (): string => {
    switch (deliveryStatus) {
      case DeliveryState.PAID: {
        return '배송 준비';
      }
      case DeliveryState.PACKING: {
        return '배송 시작';
      }
      case DeliveryState.ISSUED: {
        return '배송 완료';
      }
      case DeliveryState.COMPLETED: {
        return '배송 확정';
      }
      default: {
        return '';
      }
    }
  };

  return (
    <AuthButton
      isAbled={true}
      name={getDeliveryText()}
      onClick={handleConfirmDialog}
      style={{
        padding: '12px 24px',
        width: 'auto',
        borderRadius: '12px',
        background: '#0071E9',
      }}
    />
  );
};

export default DeliveryButton;
